import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, CanMatchFn, Route, RouterStateSnapshot, UrlSegment } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { SessionService } from 'src/app/services';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard {
  constructor(private sessionService: SessionService) {
  }

  canActivate(next?: ActivatedRouteSnapshot, state?: RouterStateSnapshot): Observable<boolean> {
    return this.sessionService.getUser().pipe(
      map(session => !!session),
      catchError((err) => {
        this.sessionService.logout();
        return of(false);
      })
    );
  }
}

export const canActivateAuthGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  return inject(AuthGuard).canActivate();
};

export const canMatchAuthGuard: CanMatchFn = (route: Route, segments: UrlSegment[]) => {
  return canActivateAuthGuard(null, null);
};
